/**
 * Public API client — certificate lookup.
 *
 * The download endpoint is NOT called from JS — the browser navigates to the
 * `redirect_url` directly so the PDF opens inline.
 */

import { apiFetch } from "./client";
import type { LookupRequest, LookupResponse } from "./types";

export async function lookup(req: LookupRequest): Promise<LookupResponse> {
  return apiFetch<LookupResponse>("/lookup", {
    method: "POST",
    body: { name: req.name, serial_number: req.serialNumber },
  });
}
